import { CalculadoraDeCaixa } from "~/classes/globalDialogs/calculadoraDeCaixa";
import { ref, watch } from 'vue';

// Criando uma instância singleton que será compartilhada por toda a aplicação
const calculadoraDeCaixa = new CalculadoraDeCaixa();
let localResolve: (value: any | PromiseLike<any>) => any;

//Garante que o total seja recalculado sempre que algum valor mudar
watch([
	() => calculadoraDeCaixa.lastro.value?.inputValue,
	() => calculadoraDeCaixa.camada.value?.inputValue,
	() => calculadoraDeCaixa.caixaSolta.value?.inputValue
], ([lastro, camada, caixaSolta]) => {

	const lastroValue = lastro == null ? 0 : Number(lastro);
	const camadaValue = camada == null ? 0 : Number(camada);
	const caixaSoltaValue = caixaSolta == null ? 0 : Number(caixaSolta);

	calculadoraDeCaixa.total.value = lastroValue * camadaValue + caixaSoltaValue;
});

function showCalculadoraDeCaixa() {
	calculadoraDeCaixa.visible.value = true;
	return new Promise(resolve => { localResolve = resolve })

	// return calcularTotalCaixasSoltas()

}


function handleResponse(value: unknown) {
	if (localResolve) localResolve(value);
	calculadoraDeCaixa.visible.value = false;
}

// Exportando um composable que sempre retorna a mesma instância


/**
 * Funcionamento
 */
/**
 * Função composable que fornece funcionalidades relacionadas à "Calculadora de Caixa".
 * 
 * Cria uma promise ao mostrar a calculadora e retorna o valor no handleResponse 
 * @returns Um objeto contendo:
 * - `calculadoraDeCaixa`: A lógica ou estado principal da calculadora.
 * - `showCalculadoraDeCaixa`: Função para controlar a exibição da calculadora.
 * - `handleResponse`: Função para lidar com as respostas ou resultados da calculadora.
 */
export default function () {
	return {
		calculadoraDeCaixa,
		showCalculadoraDeCaixa,
		handleResponse,
	}
}